import React from 'react';
import ConsultantSowbBreakdownPage from './ConsultantSowbBreakdownPage';

const EnterpriseSowbBreakdownPage: React.FC = () => {
  return <ConsultantSowbBreakdownPage scope="enterprise" />;
};

export default EnterpriseSowbBreakdownPage;

